export const TASKBAR_HEIGHT = 40;
export const WINDOW_WIDTH = 500;
export const WINDOW_HEIGHT = 400; // approximate default height
const MARGIN = 20;
const CASCADE_OFFSET = 40;

export const getCenteredPosition = (openWindowsCount: number) => {
  const centerX =
    (window.innerWidth - WINDOW_WIDTH) / 2;

  // const centerY =
  //   (window.innerHeight - TASKBAR_HEIGHT - WINDOW_HEIGHT) / 2;

  // Apply cascading Y offset
  let x = centerX;
  let y = openWindowsCount * CASCADE_OFFSET;

  // Clamp to viewport
  const maxX =
    window.innerWidth - WINDOW_WIDTH - MARGIN;

  const maxY =
    window.innerHeight -
    TASKBAR_HEIGHT -
    WINDOW_HEIGHT -
    MARGIN;

  x = Math.max(MARGIN, Math.min(x, maxX));
  y = Math.max(MARGIN, Math.min(y, maxY));

  return { x, y };
};

export const OS_RESUME_WINDOWS = {
  ABOUT_ME: 'About me',
  EXPERIENCE: 'Experience',
  PROJECTS: 'Projects',
  EDUCATION: 'Education',
  CERTIFICATIONS: 'Certifications',
  SKILLS: 'Skills',
  ASK_ME: 'Ask me',
  AI_CHAT_BOT: 'AI Chat bot',
  RESUME_PDF: 'Resume PDF',
  JS_COMPILER: 'JS Compiler',
  SHARE: 'Share',
  SHUTDOWN: 'Shutdown'
}
